module.exports = __webpack_public_path__ + "img/1-3.312501c3.jpg";